module.exports = __webpack_public_path__ + "static/img/4.10afdc9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/sp/4.png
// module id = 2dpv
// module chunks = 0